import mailClient from '../mailService'

const MailSuppressionApi = {
  async checkEmailSuppression (emails, dmsKey) {
    const resp = await mailClient().get('/api/v1/suppressions/check', { params: { emails: emails, sender_id: dmsKey } })
    return resp.data
  },

  async optOutEmail (email, reason, accountKey, dealerKey = null, campaignId = null) {
    const payload = {
      email: email,
      message: reason,
      account_id: accountKey,
      sender_id: dealerKey,
      campaign_id: campaignId
    }

    try {
      const resp = await mailClient().post('/api/v1/optOut', payload)
      return resp.data
    } catch (error) {
      throw error
    }
  },

  async reverseOptOutEmail (email, accountKey, dealerKey = null) {
    const payload = {
      email: email,
      account_id: accountKey,
      sender_id: dealerKey
    }

    try {
      const resp = await mailClient().post('/api/v1/reverseOptOut', payload)
      return resp.data
    } catch (error) {
      throw error
    }
  }
}

export default MailSuppressionApi
